import { Outlet } from "react-router-dom";

const ModeloGps = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ModeloGps;
